import { createSlice } from "@reduxjs/toolkit";
import { producerService } from '../services/producers.service'

import { openSnackBar } from "./snackBarReducer";

export const producerSlice = createSlice({
    name: "producer",
    initialState: {
        getAllProducerState: false,
        producers: [],
        getTotalProducerState: false,
        total_producers: [],
        registerProducerState: false,
        newProducer: null,
        getProducersByFilterState: false,
        producersByFilter: [],
        filter_count: 0,
        getProducerTotalCountState: false,
        count: 0,
        removeProducerState: false,
        modifyProducerState: false,
        downloadProducerImage: false
    },
    reducers: {
        getAllProducerRequest: state => {
            state.getAllProducerState = true
        },
        getAllProducerSuccess: (state, action) => {
            state.getAllProducerState = false;
            state.producers = action.payload.producers;
        },
        getAllProducerFailed: (state) => {
            state.getAllProducerState = false;
        },
        getTotalProducerRequest: state => {
            state.getTotalProducerState = true
        },
        getTotalProducerSuccess: (state, action) => {
            state.getTotalProducerState = false;
            state.total_producers = action.payload.total_producers;
        },
        getTotalProducerFailed: (state) => {
            state.getTotalProducerState = false;
        },
        registerProducerRequest: state => {
            state.registerProducerState = true
        },
        registerProducerSuccess: (state, action) => {
            state.registerProducerState = false;
            state.newProducer = action.payload.producer;
            // state.producers = [...state.producers, action.payload.producer];
        },
        registerProducerFailed: (state) => {
            state.registerProducerState = false;
            state.newProducer = null;
        },
        getProducersByFilterRequest: state => {
            state.getProducersByFilterState = true
        },
        getProducersByFilterSuccess: (state, action) => {
            state.getProducersByFilterState = false;
            state.producersByFilter = action.payload.producersByFilter;
            state.filter_count = action.payload.filter_count;
        },
        getProducersByFilterFailed: (state) => {
            state.getProducersByFilterState = false;
        },
        getProducerTotalCountRequest: state => {
            state.getProducerTotalCountState = true
        },
        getProducerTotalCountSuccess: (state, action) => {
            state.getProducerTotalCountState = false;
            state.count = action.payload.count;
        },
        getProducerTotalCountFailed: (state, action) => {
            state.getProducerTotalCountState = false;
        },
        removeProducerRequest: state => {
            state.removeProducerState = true
        },
        removeProducerSuccess: (state, action) => {
            state.removeProducerState = false;
            state.count -= 1;
        },
        removeProducerFailed: (state, action) => {
            state.removeProducerState = false;
        },
        modifyProducerRequest: state => {
            state.modifyProducerState = true
        },
        modifyProducerSuccess: (state, action) => {
            state.modifyProducerState = false;
        },
        modifyProducerFailed: (state, action) => {
            state.modifyProducerState = false;
        },
        downloadProducerImageRequest: state => {
            state.downloadProducerImageState = true
        },
        downloadProducerImageSuccess: (state, action) => {
            state.downloadProducerImageState = false;
        },
        downloadProducerImageFailed: (state, action) => {
            state.downloadProducerImageState = false;
        },
    }
});

const {
    getAllProducerRequest, getAllProducerSuccess, getAllProducerFailed,
    getTotalProducerFailed, getTotalProducerRequest, getTotalProducerSuccess,
    registerProducerFailed, registerProducerRequest, registerProducerSuccess,
    getProducersByFilterFailed, getProducersByFilterRequest, getProducersByFilterSuccess,
    getProducerTotalCountFailed, getProducerTotalCountRequest, getProducerTotalCountSuccess,
    removeProducerFailed, removeProducerRequest, removeProducerSuccess,
    modifyProducerFailed, modifyProducerRequest, modifyProducerSuccess,
    downloadProducerImageFailed, downloadProducerImageRequest, downloadProducerImageSuccess
} = producerSlice.actions;

export const registerProducer = (form) => async (dispatch) => {

    dispatch(registerProducerRequest());

    try {
        var payload = await producerService.registerProducer(form);
        dispatch(registerProducerSuccess(payload));
        return payload;
    } catch (error) {
        dispatch(registerProducerFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        // throw new Error(error);
        return false;
    }
}

export const getAllProducer = (search) => async (dispatch) => {

    dispatch(getAllProducerRequest());

    try {
        if (search) {
            var payload = await producerService.getAllProducer(search);
            // dispatch(openSnackBar({message: t("msg_success"), status: 'success'}));
            dispatch(getAllProducerSuccess(payload));
        }

    } catch (error) {
        dispatch(getAllProducerFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        throw new Error(error);
    }
}

export const getTotalProducer = () => async (dispatch) => {

    dispatch(getTotalProducerRequest());

    try {
        var payload = await producerService.getTotalProducer();
        // dispatch(openSnackBar({message: t("msg_success"), status: 'success'}));
        dispatch(getTotalProducerSuccess(payload));
    } catch (error) {
        dispatch(getTotalProducerFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        throw new Error(error);
    }
}

export const getProducersByFilter = (filter) => async (dispatch) => {

    dispatch(getProducersByFilterRequest());

    try {
        var payload = await producerService.getProducersByFilter(filter);
        // dispatch(openSnackBar({message: t("msg_success"), status: 'success'}));
        dispatch(getProducersByFilterSuccess(payload));
    } catch (error) {
        dispatch(getProducersByFilterFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        throw new Error(error);
    }
}

export const getProducerTotalCount = (filter) => async (dispatch) => {

    dispatch(getProducerTotalCountRequest());

    try {
        var payload = await producerService.getProducerTotalCount(filter);
        // dispatch(openSnackBar({message: t("msg_success"), status: 'success'}));
        dispatch(getProducerTotalCountSuccess(payload));
    } catch (error) {
        dispatch(getProducerTotalCountFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        throw new Error(error);
    }
}

export const removeProducer = (id) => async (dispatch) => {

    dispatch(removeProducerRequest());

    try {
        var payload = await producerService.removeProducer(id);
        dispatch(removeProducerSuccess(payload));
        return payload;
    } catch (error) {
        dispatch(removeProducerFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        // throw new Error(error);
        return false;
    }
}

export const modifyProducer = (id, producerData) => async (dispatch) => {

    dispatch(modifyProducerRequest());

    try {
        var payload = await producerService.modifyProducer(id, producerData);
        dispatch(modifyProducerSuccess(payload));
        return payload;
    } catch (error) {
        dispatch(modifyProducerFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        // throw new Error(error);
        return false;
    }
}

export const downloadProducerImage = () => async (dispatch) => {
    dispatch(downloadProducerImageRequest());

    try {
        var payload = await producerService.downloadProducerImage();
        dispatch(downloadProducerImageSuccess(payload));
        return payload;
    } catch (error) {
        dispatch(downloadProducerImageFailed());
        dispatch(openSnackBar({ message: error["message"], status: 'error' }));
        // throw new Error(error);
        return false;
    }
}

export default producerSlice.reducer;